import Api from '@/api/search-api'

const getProducts = async (context, payload) => {
  var filter = {...payload}
  filter.facetted = true
  if(filter.tags){
    filter.text = (filter.text + ' ' + filter.tags.join(' ')).trim()
    delete filter.tags;
  }

  if (filter.nightsArray && filter.nightsArray.length > 1) {
    filter.minNights = filter.nightsArray[0]
    filter.maxNights = filter.nightsArray[1]
  }

  if (filter.priceArray && filter.priceArray.length > 1) {
    filter.minPrice = filter.priceArray[0]
    filter.maxPrice = filter.priceArray[1]
  }

  let result = await Api.find(filter)
  context.commit('PRODUCTS_UPDATED', result)
}

const changePage = async (context, payload) => {
  if (payload.page > 0) {
    var filter = {...payload.filter}
    filter.text = (filter.text + ' ' + filter.tags.join(' ')).trim()
    delete filter.tags;
    if (filter.nightsArray && filter.nightsArray.length > 1) {
      filter.minNights = filter.nightsArray[0]
      filter.maxNights = filter.nightsArray[1]
    }

    if (filter.priceArray && filter.priceArray.length > 1) {
      filter.minPrice = filter.priceArray[0]
      filter.maxPrice = filter.priceArray[1]
    }

    filter.page = payload.page
    let result = await Api.find(filter)
    context.commit('PRODUCTS_UPDATED', result)
  }
}

const setThemeMode = (context, payload) => {
  context.commit('RESET_SEARCH')
  context.commit('SEARCH_TYPE_CHANGED', {name: 'theme', id: payload.id})
}

const setCountryMode = (context, payload) => {
  context.commit('SEARCH_TYPE_CHANGED', {name: 'country', id: payload.iso})
  context.commit('RESET_SEARCHTEXT')
}

const setDefaultSearchMode = context => {
  context.commit('SEARCH_TYPE_CHANGED', {name: 'search'})
  context.commit('RESET_SEARCHTEXT')
}

const setKeywordSearchMode = (context, keyword) => {
  context.commit('SEARCH_TYPE_CHANGED', {name: 'keyword', keyword: keyword})
}

const updateFilterFrom = (context, filter) => {
  context.commit('FILTER_UPDATED', filter)
} 

const resetSearch = context => {
  context.commit('RESET_SEARCH')
}

const resetSearchText = context => {
  context.commit('RESET_SEARCHTEXT')
}

const updateTags = (context, tags) => {
  context.commit('TAGS_UPDATED', tags)
}


const addTag = (context, tag) => {
  context.commit('TAG_ADDED', tag)
}

const removeTag = (context, tag) => {
  context.commit('TAG_REMOVED', tag)
}

const changeSortBy = (context, sort) => {
  context.commit('SORT_BY_UPDATED', sort)
}

export default {
  getProducts,
  changePage,
  setThemeMode,
  setCountryMode,
  setDefaultSearchMode,
  setKeywordSearchMode,
  resetSearch,
  resetSearchText,
  updateFilterFrom,
  addTag,
  removeTag,
  updateTags,
  changeSortBy,
}
